import React from "react";
import classes from "./PanelMensaje.css";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

function PanelMensaje({
  text,
  widthPx,
  widthPercent,
  iconType = "info",
  customChar,
  iconAriaLabel,
  iconColor, 
  className = "",
}) {
  const computedWidth =
    typeof widthPercent === "number"
      ? `${widthPercent}%`
      : typeof widthPx === "number"
      ? `${widthPx}px`
      : undefined;

  const finalColor = iconColor || "#9e9e9e"; 
  const iconStyle = { color: finalColor };

  const renderIcon = () => {
    switch (iconType) {
      case "alert": return <WarningIcon style={iconStyle} aria-label={iconAriaLabel || "Alerta"} />;
      case "check": return <CheckCircleIcon style={iconStyle} aria-label={iconAriaLabel || "Confirmación"} />;
      case "error": return <ErrorOutlineIcon style={iconStyle} aria-label={iconAriaLabel || "Error"} />;
      case "custom":
        return <span style={iconStyle} aria-label={iconAriaLabel || "Icono"} role="img">{customChar || "•"}</span>;
      default: return <InfoOutlinedIcon style={iconStyle} aria-label={iconAriaLabel || "Información"} />;
    }
  };

  return (
    <div
      className={`${classes.panelContainer} ${classes.panelMensaje} ${className}`}
      style={computedWidth ? { width: computedWidth } : undefined}
    >
      <div className={classes.containerFlexRow}>
        <div className={classes.panelMensaje__icono}>
          <span className={classes.panelMensaje__aro} style={{ borderColor: finalColor }}>
            {renderIcon()}
          </span>
        </div>
        <div className={classes.panelMensaje__texto}>
          <div style={{ width: "100%" }}>{text}</div>
        </div>
      </div>
    </div>
  );
}

export default PanelMensaje;
